var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8561 13.144C9.68615 11.974 8.80415 10.664 8.21815 9.33499C8.09415 9.05399 8.16715 8.72499 8.38415 8.50799L9.20315 7.68999C9.87415 7.01899 9.87415 6.06999 9.28815 5.48399L8.11415 4.30999C7.33315 3.52899 6.06715 3.52899 5.28615 4.30999L4.63415 4.96199C3.89315 5.70299 3.58415 6.77199 3.78415 7.83199C4.27815 10.445 5.79615 13.306 8.24515 15.755C10.6941 18.204 13.5551 19.722 16.1681 20.216C17.2281 20.416 18.2971 20.107 19.0381 19.366L19.6891 18.715C20.4701 17.934 20.4701 16.668 19.6891 15.887L18.5161 14.714C17.9301 14.128 16.9801 14.128 16.3951 14.714L15.4921 15.618C15.2751 15.835 14.9461 15.908 14.6651 15.784C13.3361 15.197 12.0261 14.314 10.8561 13.144Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2254b162106e7a4da57081a88dd0d45c.svg";
export { ForwardRef as ReactComponent };